"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormattedDate = void 0;
var React = require("react");
var timeago_js_1 = require("timeago.js");
var twoDigitsDateTime = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit'
};
var FormattedDate = function (_a) {
    var value = _a.value, className = _a.className;
    if (!value)
        return null;
    var formatted = value.toLocaleDateString(undefined, twoDigitsDateTime);
    var relative = (0, timeago_js_1.format)(value);
    return (React.createElement("p", { className: className },
        relative,
        " \u00B7 ",
        formatted));
};
exports.FormattedDate = FormattedDate;
//# sourceMappingURL=FormattedDate.js.map